import { authorizedFetch, parseApiErrorMessage } from '@/lib/api'
import type { NotificationPreferenceItem } from '@/hooks/use-notifications'

export const APPLICATION_RECEIVED_CATEGORY = 'application.received'

export function applicationReceivedEmailEnabled(
  items: NotificationPreferenceItem[] | undefined,
): boolean {
  const row = items?.find((item) => item.category === APPLICATION_RECEIVED_CATEGORY)
  return row?.email_enabled ?? true
}

export function applicationReceivedInAppEnabled(
  items: NotificationPreferenceItem[] | undefined,
): boolean {
  const row = items?.find((item) => item.category === APPLICATION_RECEIVED_CATEGORY)
  return row?.in_app_enabled ?? true
}

export async function saveApplicationReceivedEmailPreference(opts: {
  emailEnabled: boolean
  inAppEnabled: boolean
}): Promise<void> {
  const response = await authorizedFetch('/api/notifications/preferences', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      preferences: [
        {
          category: APPLICATION_RECEIVED_CATEGORY,
          email_enabled: opts.emailEnabled,
          in_app_enabled: opts.inAppEnabled,
        },
      ],
    }),
  })
  if (!response.ok) {
    throw new Error(await parseApiErrorMessage(response, 'Failed to save notification settings'))
  }
}
